export const NAME = 'auth';
export const LOGIN_FORM_NAME = 'loginForm';
export const SIGNUP_FORM_NAME = 'signupForm';
export const FORGOT_PASSWORD_FORM_NAME = 'forgotPasswordForm';
export const RESET_PASSWORD_FORM_NAME = 'resetPasswordForm';
export const UPDATE_USER_FORM_NAME = 'updateUserForm';
export const CHANGE_PASSWORD_FORM_NAME = 'changePasswordForm';
export const TOKENS_TABLE_NAME = 'personalAccessTokens';
